import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Entailment, _single } from "../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { SelectTypeProcees } from "../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { _DocumentSignPanel, _SignAndApprovalitem, _SignAndApprovalPanel } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../theme/Component/BasicButton";
import { EditorSignAndApprovalPanel } from "./EditorSignAndApprovalPanel";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectFunctionalArea } from "../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { DocumentTRDEditor } from "../../bpm/config/DocumentTRDEditor";
import { DocumentTemplateEditor } from "../../bpm/config/DocumentTemplateEditor";

interface Props {
    IDSignAndApprovalPanel: number;
}

export const RequisitosFirma = ({ IDSignAndApprovalPanel }: Props) => {

    const { instance, setBean, bean, lista, setLista, handleChange, update } = useDataBean(_DocumentSignPanel);
    const single = Singleton.getInstance();
    const [verfirmas, setVerfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDSignAndApprovalPanel])

    const getLista = () => {
        instance.getDocumentSingPanelRender(IDSignAndApprovalPanel, 1).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            State: 1,
            IDSignAndApprovalPanel: IDSignAndApprovalPanel,

        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        instance.updateDocumentSignPanel(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }


    const head = [
        { title: 'ID', property: 'IDDocumentSignPanel', visible: true },
        // { title: 'ID Documennto', property: 'IDHiringModalityDocument', visible: true },
        { title: 'Documento', property: 'Description', visible: true },
        { title: 'TRD', property: 'TRDName', visible: true },
        // { title: 'Fecha', property: 'Since', visible: true },
        // { title: 'Usuario logueado', property: 'IDEmployee', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <>
            <div className="row">

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentTemplateEditor config={bean.Description} onChange={(e) => { console.log(e); setBean({ ...bean, "IDHiringModalityDocument": e.IDHiringModalityDocument }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={modalC} eventModal={deleteItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <p>Eliminar el registo {bean.Title}</p>
                            </div>
                        </div>
                    </ModalConfirm>
                </div>

            </div>
        </>
        
    )
}